const body = document.body;

if (body.classList.contains('modbox-home')) {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopMotion = window.matchMedia('(min-width: 700px) and (hover: hover) and (pointer: fine)');
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const hero = document.querySelector('.shopify-section--slideshow:first-child .modbox-hero');

  let pointerX = 0;
  let pointerY = 0;
  let heroFrame = 0;

  const updateHeroDepth = () => {
    heroFrame = 0;

    if (!hero || reducedMotion.matches || !desktopMotion.matches || !body.classList.contains('modbox-home--parallax')) {
      return;
    }

    const rect = hero.getBoundingClientRect();
    const scrollDepth = clamp(-rect.top * 0.012, 0, 6);

    hero.style.setProperty('--modbox-bg-x', `${pointerX * -0.35}px`);
    hero.style.setProperty('--modbox-bg-y', `${clamp(scrollDepth - pointerY * 0.2, -4, 8)}px`);
    hero.style.setProperty('--modbox-middle-x', `${pointerX * 0.55}px`);
    hero.style.setProperty('--modbox-middle-y', `${clamp(pointerY * 0.45 + scrollDepth * 0.25, -4, 6)}px`);
    hero.style.setProperty('--modbox-foreground-x', `${pointerX * 0.9}px`);
    hero.style.setProperty('--modbox-foreground-y', `${clamp(pointerY * 0.75 + scrollDepth * 0.1, -4, 5)}px`);
  };

  const requestHeroUpdate = () => {
    if (!heroFrame) {
      heroFrame = window.requestAnimationFrame(updateHeroDepth);
    }
  };

  if (hero && body.classList.contains('modbox-home--parallax')) {
    hero.addEventListener('pointermove', (event) => {
      if (reducedMotion.matches || !desktopMotion.matches) {
        return;
      }

      const rect = hero.getBoundingClientRect();
      pointerX = clamp(((event.clientX - rect.left) / rect.width - 0.5) * 8, -4, 4);
      pointerY = clamp(((event.clientY - rect.top) / rect.height - 0.5) * 8, -4, 4);
      requestHeroUpdate();
    }, { passive: true });

    hero.addEventListener('pointerleave', () => {
      pointerX = 0;
      pointerY = 0;
      requestHeroUpdate();
    }, { passive: true });

    document.addEventListener('scroll', requestHeroUpdate, { passive: true });
    requestHeroUpdate();
  }

  const initializeCardTilt = (root = document) => {
    if (!body.classList.contains('modbox-home--card-tilt') || reducedMotion.matches || !desktopMotion.matches) {
      return;
    }

    root.querySelectorAll('.modbox-shop-card:not([data-modbox-tilt-ready])').forEach((card) => {
      card.dataset.modboxTiltReady = 'true';
      let cardRect;
      const resetCardTilt = () => {
        cardRect = undefined;
        card.classList.remove('is-tilting');
        card.style.setProperty('--modbox-card-rx', '0deg');
        card.style.setProperty('--modbox-card-ry', '0deg');
      };

      card.addEventListener('pointerenter', () => {
        cardRect = card.getBoundingClientRect();
        card.classList.add('is-tilting');
      }, { passive: true });

      card.addEventListener('pointermove', (event) => {
        cardRect ||= card.getBoundingClientRect();
        card.classList.add('is-tilting');
        const x = clamp((event.clientX - cardRect.left) / cardRect.width - 0.5, -0.5, 0.5);
        const y = clamp((event.clientY - cardRect.top) / cardRect.height - 0.5, -0.5, 0.5);

        card.style.setProperty('--modbox-card-rx', `${y * -5}deg`);
        card.style.setProperty('--modbox-card-ry', `${x * 5}deg`);
      }, { passive: true });

      card.addEventListener('pointerleave', resetCardTilt, { passive: true });
      card.addEventListener('pointercancel', resetCardTilt, { passive: true });
      card.addEventListener('pointerout', (event) => {
        if (!card.contains(event.relatedTarget)) {
          resetCardTilt();
        }
      }, { passive: true });
    });
  };

  let revealObserver;

  const initializeScrollReveal = (root = document) => {
    if (!body.classList.contains('modbox-home--scroll-reveal') || reducedMotion.matches) {
      return;
    }

    revealObserver ||= new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    const sections = root.querySelectorAll('#main > .shopify-section:not(:first-child):not([data-modbox-reveal])');

    if (!sections.length) {
      return;
    }

    body.classList.add('modbox-reveal-preparing');

    sections.forEach((section) => {
      section.dataset.modboxReveal = 'true';
    });

    window.requestAnimationFrame(() => {
      body.classList.add('modbox-reveal-ready');
      body.classList.remove('modbox-reveal-preparing');
      sections.forEach((section) => revealObserver.observe(section));
    });
  };

  initializeCardTilt();
  initializeScrollReveal();

  document.addEventListener('shopify:section:load', (event) => {
    initializeCardTilt(event.target);
    initializeScrollReveal(document);
  });
}
